const { registerBlockType } = wp.blocks;

import attributes from './attributes';
import Editor from './edit';
import Save from './save';

registerBlockType('app/accordion-container', {
  title: 'Accordion Container',
  description: 'Componente para utilização de Accordions',
  icon: 'menu-alt3',
  category: 'design',
  attributes,

  edit: (props) => <Editor {...props} />,
  save: (props) => <Save {...props} />,
});
